import { FileListToArrayBaseValueConverter } from 'General/Resources/ValueConverters/FileListToArrayBase';
export class FileListToArrayValueConverter extends FileListToArrayBaseValueConverter {

}